<template>
	<div
		v-for="series in seriesList"
		:key="(series['0020000E']?.Value?.[0] as string)"
	>
		<input
			v-if="selectable"
			class="mr-2 checkbox checkbox-sm"
			type="checkbox"
			:disabled="typeof series.disallowed === 'string'"
			v-model="series.selected"
			:id="'check' + series['0020000E']?.Value?.[0]"
		/>
		<label
			:for="'check' + series['0020000E']?.Value?.[0]"
		>
			<span class="text-base-content/70">
				{{ Number(series["00200011"]?.Value[0]) }}:
			</span>
			<!-- Modality -->
			{{ series["0008103E"]?.Value?.[0] || "Unnamed series" }} ({{
				series["00080060"]?.Value?.[0]
			}})
			<!-- Number of instances -->
			({{ series["00201209"]?.Value[0] || "unknown" }} images)
			<!-- If combining several series with same SeriesInstanceUID -->
			<template v-if="series.combined">
				<span class="text-base-content/70">
					Combining {{ series.combined }} series with identical UID
				</span>
			</template>
		</label>
	</div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { ResultSeries } from "./types";

const props = defineProps<{
	seriesList: ResultSeries[];
	selectable: boolean;
}>();
const emit = defineEmits(["update"]);

const selectedValues = computed(() => {
	return props.seriesList.map((s) => s.selected);
});

watch(selectedValues, () => {
	emit("update");
});
</script>

<style></style>
